import { SCORE, multiplierFor } from '@accra/shared';
import type { RunState } from '../game/RunState';
import { isFast } from './driving';
import { scoreBoost } from './pickups/roadBonuses';

export function currentMultiplier(state: RunState): number {
  return multiplierFor(state.passengers.length, isFast(state.bus)) * scoreBoost(state);
}

export function addDistanceScore(state: RunState, metres: number): void {
  state.stats.metres += metres;
  state.stats.score += metres * SCORE.perMetre * currentMultiplier(state);
}

export function addBonus(state: RunState, points: number): void {
  state.stats.score += points * currentMultiplier(state);
}

export function farePoints(pesewas: number): number {
  return (pesewas / 100) * SCORE.perCedi;
}
